import { z } from 'zod';

import { TransitSchema } from './TransitSchema';

export const TransitEditDataSchema = z.object({
  transit: TransitSchema.partial().extend({ _id: z.any() }),
  refreshCustomerData: z.boolean().optional(),
  overwriteTrace: z.boolean().optional(),
});
export type TransitEditData = z.infer<typeof TransitEditDataSchema>;
